//import packages from node modules
import React, {useCallback, useEffect, useRef, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {withRouter} from "react-router-dom"
import PropTypes from "prop-types";

//import utility functions
import PRODUCT_API, {cancelGetProduct} from "../../../utilities/api/product"
import {
    getDataFromSuccessResponse,
    getErrorFromFailResponse
} from "../../../utilities/function/apiResponse"

import {
    getPriceByBillingCycleID
} from "../../../utilities/function/billingCycle"

import {
    getFilteredConfigurationList
} from "../../../utilities/function/configuration"

import {updateConfig} from "../../../app/action"
import {DOMAIN_TYPE} from "../../../utilities/function/servicetype"

//import shared components
import SolidButton from "../button/solidbutton"
import Loading from "../loading"
import {PremiumFlag} from "../premiumflag"
import PriceDomain from "../pricedomain"
import Ellipsis from "../ellipsis";

let SearchDomainResultItem = (props) => {
    //define variables
    const {item, selected, searchItemCallback, isTransferMode} = props
    const {domain, price, available, product_id, tld,premium} = item
    const cid = domain+tld

    //define variables from hooks
    const [selectedPrice, setSelectedPrice] = useState(null)
    const [requestRegisterDomain, setRequestRegisterDomain] = useState({})
    const initFlag = useRef(false)
    const configurations = useSelector(state => state.app.configurations)
    const dispatch = useDispatch()

    //define functions
    const getItemIsAvailable = () => {
        return available
    }
    const itemOnclick = () => {
        if (cancelGetProduct) {
            cancelGetProduct()
        }
        setRequestRegisterDomain({
            ...requestRegisterDomain,
            status: 'loading'
        })
        PRODUCT_API.getProduct([product_id]).then(successresponse => {
            const data = getDataFromSuccessResponse(successresponse)
            const domain_cid = domain + tld
            const selectedProduct = data.find(item => item.id === product_id)
            const config = {
                selectedProduct,
                domainSearchResult: item,
                billing_cycle_id: selectedPrice.billing_cycle_id,
                order_type: 'transfer',
                step: 0
            }
            if (isTransferMode) {
                config['order_type'] = 'transfer'
            } else {
                config['order_type'] = 'register'
            }
            updateConfig(configurations, domain_cid, config, dispatch)
            setRequestRegisterDomain({
                ...requestRegisterDomain,
                status: 'success',
                data
            })
            window.setTimeout(()=>{
                if (searchItemCallback) {
                    searchItemCallback(1, configurations[domain_cid])
                }
            },500)
        }, errorresponse => {
            const error = getErrorFromFailResponse(errorresponse)
            setRequestRegisterDomain({
                ...requestRegisterDomain,
                status: 'error',
                error
            })
        })
    }

    //define callback functions
    const isAdded = useCallback(()=>{
        const list = getFilteredConfigurationList(DOMAIN_TYPE, configurations, 'all')
        if (list && Array.isArray(list) && list.length > 0) {
            return list.find(i => {
                const getName = () => {
                    if (i.domainSearchResult) {
                        const {domain, tld} = i.domainSearchResult
                        return domain + tld
                    } else {
                        if (i.uuid && i.name) {
                            return i.name
                        }
                    }
                    return null
                }
                return domain + tld === getName()
            })
        }
        return false
    },[configurations,domain,tld])
    const getCurrentBillingCycle = useCallback(()=>{
        if(cid && configurations && configurations[cid]){
            const {billing_cycle_id} = configurations[cid]
            if(billing_cycle_id){
                const selected = getPriceByBillingCycleID(price,billing_cycle_id)
                return selected
            }
        }
        return null
    },[configurations,cid,price])
    const priceDomainCallback = useCallback(priceitem=>{
        setSelectedPrice(priceitem)
        updateConfig(configurations,cid,{
            billing_cycle_id: priceitem.billing_cycle_id
        },dispatch)
    },[configurations,cid,dispatch])

    //define render functions
    const renderIsAvailable = () => {
        return (<div className={'of-search-domain-result-item__is-available'}>
            <div
                className={`of-search-domain-result-item__is-available-wrapper${getItemIsAvailable() ? ' status-background-1-10' : ' text-background-4-10'}`}>
                <i
                    className={`icon icon-of-${getItemIsAvailable() ? 'tick-solid success status-font-1-100' : 'x fail text-font-1-100'}`}/>
            </div>
        </div>)
    }
    const renderButton = () => {
        if (getItemIsAvailable()) {
            if (isAdded()) {
                return (<div className={'of-search-domain-result-item__button-wrapper'}>
                    <SolidButton
                        className={'of-search-domain-result-item__button of-search-domain-result-item__button--added status-background-1-10 status-font-1-100'}
                        isDisabled={true}><i className={'icon icon-of-tick-solid'}/>Added</SolidButton>
                </div>)
            }
            return (<div
                className={`of-search-domain-result-item__button-wrapper${requestRegisterDomain.status === 'loading' ? ' of-search-domain-result-item__button-wrapper--loading' : ''}`}>
                {requestRegisterDomain.status !== 'loading' ?
                    <SolidButton onClick={itemOnclick} className={'of-search-domain-result-item__button text-font-1-100'}
                                 isSecondary={true}>{isTransferMode ? 'Transfer' : 'Register'}</SolidButton> : <div
                        className={'of-search-domain-result-item__button of-search-domain-result-item__button--dummy'}></div>}
                {requestRegisterDomain.status === 'loading' ? <Loading
                    className={`of-search-domain-result-item-loading`}/> : <></>}
            </div>)
        }
        return (<div className={'of-search-domain-result-item__button-wrapper'}>
            <SolidButton className={'of-search-domain-result-item__button'}
                         isDisabled={true}>{isTransferMode ? 'Not Registered' : 'Taken'}
            </SolidButton>
        </div>)
    }
    const renderPremiumFlag = () =>{
        if(premium){
            return <PremiumFlag itemresult={item}/>
        }
        return (<></>)
    }
    const renderDomainNameElipsis = () => {
        const domainname = domain + tld
        const renderDefault = () => {
            return(
                <div className={'of-search-domain-result-item__domain-wrapper'}>
                    <span className={getItemIsAvailable() ? 'domain text-font-3-100' : 'domain text-font-4-100'}>{domain}</span>
                    <span className={getItemIsAvailable() ? 'tld text-font-1-100' : 'domain text-font-4-100'}>{tld}</span>
                </div>
            )
        }
        const isActive = () => {
            return (domainname && domainname.length >32)
        }
        const renderFormat = () => {
            //last 10 characters
            const getLast10 = () => {
                return domain.substring(domain.length - 10)
            }
            //first 10 characters
            const getFirst10 = () => {
                return domain.substring(0,10)
            }
            return( <div className={'of-search-domain-result-item__domain-wrapper'}>
                <span className={getItemIsAvailable() ? 'domain text-font-3-100' : 'domain text-font-4-100'}>{getFirst10()}...{getLast10()}</span>
                <span className={getItemIsAvailable() ? 'tld text-font-1-100' : 'domain text-font-4-100'}>{tld}</span>
            </div>)
        }
        return(
            <Ellipsis className={'of-search-domain-ellipsis'} tooltip={domainname} isActive={isActive()} format={renderFormat()} >
                {renderDefault()}
            </Ellipsis>
        )

    }

    useEffect(() => {
        if (initFlag.current === false) {
            if (price && Array.isArray(price) && price.length > 0) {
                if (isTransferMode) {
                    const transferPrice = price.find(item => item.type === 'transfer')
                    if (transferPrice) {
                        setSelectedPrice(transferPrice)
                    }
                } else {
                    if(isAdded() && getCurrentBillingCycle()){
                        setSelectedPrice(getCurrentBillingCycle())
                    }else{
                        setSelectedPrice(price[0])
                    }
                }
            }
        }
    }, [price, isTransferMode,isAdded,getCurrentBillingCycle])

    return (<div
        className={`of-search-domain-result-item${selected ? ' of-search-domain-result-item--selected' : ''}${getItemIsAvailable() ? ' of-search-domain-result-item--available' : ' of-search-domain-result-item--not-available'}`}>
        <div className={'of-search-domain-result-item__wrapper'}>
            {renderIsAvailable()}
            <div className={'of-search-domain-result-item__domain'}>
                {renderDomainNameElipsis()}
                {renderPremiumFlag()}
            </div>
            <PriceDomain callback={priceDomainCallback}
                         value={selectedPrice}
                         item={item}
                         type={isTransferMode ? 'transfer' : 'register'}/>
            {renderButton()}
        </div>
    </div>)
}

SearchDomainResultItem = withRouter(SearchDomainResultItem)

SearchDomainResultItem.propTypes = {
    item: PropTypes.object,
    selected: PropTypes.bool,
    location: PropTypes.any,
    searchItemCallback: PropTypes.any,
    isTransferMode: PropTypes.bool
}

export default SearchDomainResultItem